import { render } from "./ProfileTop.vue?vue&type=template&id=5f4839fa"
import script from "./ProfileTop.vue?vue&type=script&lang=js"
export * from "./ProfileTop.vue?vue&type=script&lang=js"

import "./ProfileTop.vue?vue&type=style&index=0&id=5f4839fa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__